import * as React from 'react';
import { CHART_COLOR_AMBER, CHART_COLOR_BG_TRANSPARENT, CHART_COLOR_GRAY, CHART_COLOR_GREEN } from './colors';
import type { BooleanMetric } from './types';

interface BooleanBarProps {
  metric: BooleanMetric;
  /**
   * Width of the chart
   * @default 300
   */
  width?: number;
  /**
   * Height of the chart
   * @default 20
   */
  height?: number;
}

const PAD_L = 10;
const PAD_R = 10;

/**
 * Renders a thin horizontal bar
 * Green 100% when true, amber 50% when false
 */
const BooleanBar = React.forwardRef<SVGSVGElement, BooleanBarProps>((props, forwardedRef) => {
  const { metric, width = 300, height = 20 } = props;
  const { currentValue } = metric;

  const CW = width - PAD_L - PAD_R;

  const barH = 5;
  const barX = PAD_L;
  const barY = (height - barH) / 2; // Center the bar vertically
  const fullW = CW;
  const fillW = currentValue ? fullW : fullW * 0.5;
  const fillColor = currentValue ? CHART_COLOR_GREEN : CHART_COLOR_AMBER;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      ref={forwardedRef}
      className="w-full h-auto"
      aria-label={`Boolean bar chart showing current value ${currentValue}`}
    >
      <rect width={width} height={height} rx="6" fill={CHART_COLOR_BG_TRANSPARENT} />
      <rect x={barX} y={barY} width={fullW} height={barH} rx="2" fill={CHART_COLOR_GRAY} />
      <rect x={barX} y={barY} width={fillW} height={barH} rx="2" fill={fillColor} opacity="0.8" />
    </svg>
  );
});

export type { BooleanBarProps };
export { BooleanBar };
